module.exports = __webpack_public_path__ + "static/media/en-flag.da17be14.svg";